import axios from 'axios';
import { BASE_PATH } from './routes';

const BASE_URL = BASE_PATH;

axios.defaults.timeout = 6000;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';

export function apiUrl(endpoint: string, version = 'v1'): string {
    return `${BASE_URL}/api/${version}/${endpoint}`;
}
